import { RequestResponsePattern } from '../../../../../../types/Request'
import { getApi } from '../../../../../../utils/requestApi'
import { DOMAIN } from '../../../../../../var_env.'
import { setLista, setRequestGetData, setRequestGetError, setRequestGetLoading, setRequestGetMessage } from '../../Reducers/PessoaHidrometroReducer'
import { PessoaHidrometroType } from '../../Types/PessoaHidrometroType'

export default async function get(apiController: string, idPessoa: number, dispatch: Function){
    try {
        dispatch(setRequestGetLoading())

        const endpoint = DOMAIN
        const params = `/${apiController}/?idPessoa=${idPessoa}`
        const response: RequestResponsePattern<PessoaHidrometroType[]> = await getApi({ endpoint, params })
        
        if(response){
            dispatch(setRequestGetData(response))
            if(!response.flagErro) {
                dispatch(setLista(response.listaResultados))
                localStorage.setItem(apiController, JSON.stringify(response.listaResultados))
            } else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')
    } catch (error: any) {
        console.log(error)
        dispatch(setRequestGetMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestGetError())
    }
}